import React, { PropsWithChildren } from 'react'
import { BaseWidgetProps } from './types'
import { BaseWidgetStyled } from './BaseWidget.style'

export const BaseWidget = React.forwardRef<
  HTMLDivElement,
  PropsWithChildren<BaseWidgetProps & { debug?: () => void }>
>(({ size, alert, children }, ref) => {
  return (
    <BaseWidgetStyled ref={ref} isDragging={false} size={size} alert={alert}>
      {children}
    </BaseWidgetStyled>
  )
})
